<template>
  <div class="about">
    <h1>Admin Login</h1>
    <div v-if="!loggedIn">
      <NeedLogin></NeedLogin>
      <div>.</div>
    </div>
    <div v-else>
      <v-card outlined raised>
        <div v-if="!isAlertVisible">
          <!-- <UserApiSearch @selected-regid="setRegId"></UserApiSearch> -->
          <v-form v-model="isValid">
            <!-- <AC @ac_changed="setAc"></AC> -->
            <PW @pw_changed="setPw"></PW>
            <v-text-field
              v-model="regid"
              outlined
              required
              :rules="regidRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-model="ac"
              outlined
              required
              :rules="acRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-model="pw"
              outlined
              required
              :rules="pwRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!isValid"
                color="primary"
                @click="adminLogin"
                :class="`d-flex justify-space-around mb-6`"
                >OK <v-icon right small>fa-user-cog</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn icon @click="snackbar = true">
                <v-icon small>fa-info-circle</v-icon>
              </v-btn>
              <v-btn icon :to="cancellink.to">
                <v-icon small>fa-times-circle</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-row>
          </v-form>
        </div>
        <v-alert type="success" :value="isAlertVisible" dense>
          {{ statusResultMsg }}
        </v-alert>
        <v-alert type="error" :value="isWarningAlertVisible" dense>
          {{ statusResultMsg }}
        </v-alert>
      </v-card>
    </div>
    <v-snackbar v-model="snackbar">
      {{ snackbartext }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// @ is an alias to /src
// import UserApiSearch from "@/components/airbox/UserApiSearch.vue";
// import AC from "@/components/Admin/Ac.vue";
import PW from "@/components/Admin/Pw.vue";
import axios from "axios";
import NeedLogin from "@/components/Admin/NeedLogin.vue";

export default {
  name: "AdminLogin",
  // regid: Number,
  data() {
    return {
      regid: Number,
      ac: String,
      pw: String,
      eyevalueac: true,
      eyevaluepw: true,
      isValid: true,
      regidRules: [(v) => !!v || "User is required"],
      acRules: [(v) => !!v || "Access code is required"],
      pwRules: [(v) => !!v || "Password is required"],
      cancellink: { to: "/checkin" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      cancelBtnText: "",
      statuses: [],
      errors: [],
      snackbar: false,
      snackbartext: "No info.",
      loginModel: null,
      loggedIn: false
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.regid = null;
    this.isValid = false;
    this.ac = null;
    this.pw = null;
    this.getCookies();
  },
  methods: {
    setRegId(id) {
      this.regid = id;
      //   console.log(id);
    },
    setAc(value) {
      this.ac = value;
      //   console.log(id);
    },
    setPw(value) {
      this.pw = value;
      //   console.log(id);
    },
    setLogInModel() {
      var regId = this.regid;
      var ac = this.ac;
      var pw = this.pw;
      this.loginModel = JSON.stringify({ regId, ac, pw });
      this.$emit("login", this.loginModel);
      //   console.log(id);
    },
    adminLogin() {
      var regId = this.regid;
      var ac = this.ac;
      var pw = this.pw;
      var toSubmit = JSON.stringify({ ac, pw });
      const uri = this.baseUrl + "adminlogin/" + regId;
      // console.log(toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            console.log(response.data);
            this.setLogInModel();
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regId = this.cookieRegId;
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
        // this.setLogInModel();
      }
    },
  },
  components: {
    // UserApiSearch,
    // AC,
    PW,
    NeedLogin
  },
};
</script>